export interface OrderPositionPrice {
  isPriceOverriddenAsNet: boolean | null;
  grossPrice: number;
  netPrice: number;
}

export const isOrderPositionPrice = (value: unknown): value is OrderPositionPrice => {
  if (!value || typeof value !== 'object') return false;

  const obj = value as Record<string, unknown>;
  return (
    'isPriceOverriddenAsNet' in obj &&
    (typeof obj.isPriceOverriddenAsNet === 'boolean' || obj.isPriceOverriddenAsNet === null) &&
    'grossPrice' in obj &&
    typeof obj.grossPrice === 'number' &&
    'netPrice' in obj &&
    typeof obj.netPrice === 'number'
  );
};
